<custom-modal-card
  *ngIf="{
    violations: violations$ | async,
    liveStreamsEntry: liveStreamsEntry$ | async,
    liveStream: liveStream()
  } as STATE"
  class="edit-attachment mat-dialog-transparent"
>
  <ng-container header>
    <default-modal-header
      [title]="modalTitle"
      [description]="modalDescription"
    ></default-modal-header>
  </ng-container>
  <ng-container body>
    <form
      [formGroup]="form"
      id="liveStream"
      (ngSubmit)="onSubmit()"
      class="resource-form"
    >
      <article>
        <mat-label>Intitulé *</mat-label>
        <mat-form-field color="primary">
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <input
            formControlName="title"
            matInput
            placeholder="Entrez l'intitulé du liveStream"
          />
        </mat-form-field>
        <mat-error
          *ngIf="form.get('title')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Description</mat-label>
        <mat-form-field color="primary">
          <textarea
            formControlName="description"
            matInput
            rows="3"
            placeholder="Entrez la description du liveStream."
          ></textarea>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('description')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Type du media *</mat-label>
        <mat-form-field>
          <mat-select formControlName="type" placeholder="Sélectionner le type">
            @for (type of mediaSourceTypeArray; track type.key) {
              <mat-option [value]="type.value">{{
                type.value | mediaSourceType
              }}</mat-option>
            }
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
      </article>

      <article *ngIf="form.value.type?.length">
        <mat-label>Source *</mat-label>
        <mat-form-field
          color="primary"
          *ngIf="
            form.value.type !== mediaSourceType.iframe &&
            form.value.type !== mediaSourceType.kalturaMediaEntry
          "
        >
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <input
            type="url"
            formControlName="source"
            matInput
            placeholder="Entrez l'url de la source"
          />
        </mat-form-field>
        <mat-form-field
          *ngIf="form.value.type === mediaSourceType.kalturaMediaEntry"
        >
          <mat-select
            formControlName="source"
            placeholder="Sélectionnez la source"
            *ngIf="STATE.liveStreamsEntry"
            (valueChange)="onChangeKalturaMediaEntry($event)"
          >
            @if (!STATE.liveStreamsEntry.length) {
              <mat-option>aucune source</mat-option>
            } @else {
              @for (source of STATE.liveStreamsEntry; track source) {
                <mat-option [value]="source.id">{{ source.name }}</mat-option>
              }
            }
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
        <mat-form-field
          color="primary"
          *ngIf="form.value.type === mediaSourceType.iframe"
        >
          <textarea
            formControlName="source"
            matInput
            rows="3"
            placeholder="Code iframe complet."
          ></textarea>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('source')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-checkbox color="primary" formControlName="markedAsDefault"
          >Définir par défaut</mat-checkbox
        >
        <mat-error *ngIf="form.get('name')?.getError('httpError') as httpError">
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
    </form>
  </ng-container>

  <footer footer class="resource-form">
    <button
      type="submit"
      [attr.loading]="isSubmitting()"
      [disabled]="form.invalid || isSubmitting() || form.pristine"
      class="btn btn--primary-light btn--full"
      form="liveStream"
    >
      {{
        STATE.liveStream
          ? 'Mettre à jour les informations'
          : 'Créer le liveStream'
      }}
    </button>
  </footer>
</custom-modal-card>
